export default {
    notifications: [],
    totalUnseenNotifications: null,
    selectedNotification: null,
    error: false,
    errorMessage: ''
  }